import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Paper, Stack, Typography } from '@mui/material';
import { Scrollbar } from 'app/components';
import { resolveVideoAdapter } from 'app/video';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
const MapTransportBroadcastEventList = function MapTransportBroadcastEventList({ checkedItem, onChangePlayTime, }) {
    var _a;
    const broadcast = useSelector((state) => { var _a; return (_a = state.map.transportSelectedItem) === null || _a === void 0 ? void 0 : _a.broadcast; });
    const events = (_a = broadcast === null || broadcast === void 0 ? void 0 : broadcast.events) !== null && _a !== void 0 ? _a : [];
    const videoAdapter = resolveVideoAdapter(broadcast);
    const [expanded, setExpanded] = useState(false);
    const handleChangeAccordion = (panel, time) => (_event, isExpanded) => {
        if (isExpanded) {
            onChangePlayTime(moment(time).diff(moment(time).startOf('day'), 'seconds'));
        }
        setExpanded(isExpanded ? panel : false);
    };
    useEffect(() => {
        setExpanded(checkedItem === -1 ? false : checkedItem);
    }, [checkedItem]);
    return (React.createElement(Stack, { sx: (theme) => ({
            width: '100%',
            height: '100%',
            '.MuiPaper-elevation:first-of-type': {
                border: 'none',
            },
            '.MuiAccordion-root': {
                boxShadow: 'none',
                borderRadius: '0',
                transition: 'background-color ' + theme.transitions.duration.shortest + 'ms ' + theme.transitions.easing.easeInOut + ' 0ms',
                '&:before': {
                    display: 'none',
                },
                '&.Mui-expanded': {
                    margin: '0',
                },
                '.MuiAccordionSummary-expandIconWrapper': {
                    svg: {
                        fontSize: '18px',
                    },
                },
            },
            '.MuiAccordionDetails-root': {
                padding: theme.spacing(1, 2),
                '.MuiPaper-root': {
                    position: 'relative',
                    border: 'none',
                    '.MuiPaper-row': {
                        display: 'grid',
                        gap: 1,
                        gridTemplateColumns: 'repeat(7, 1fr)',
                        '&:nth-of-type(2) .MuiTypography-root:last-of-type': {
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        },
                        '.MuiTypography-root:first-of-type': {
                            color: 'text.secondary',
                        },
                    },
                    '.MuiPaper-row .MuiTypography-root:first-of-type': {
                        gridRow: '1',
                        gridColumn: '1/3',
                    },
                    '.MuiPaper-row .MuiTypography-root:last-of-type': {
                        gridRow: '1',
                        gridColumn: '3/8',
                        'span:nth-of-type(2)': {
                            paddingLeft: theme.spacing(0.5),
                        },
                    },
                },
            },
            '.MuiAccordionSummary-root': {
                padding: theme.spacing(0, 2),
                minHeight: '24px',
                transition: 'none',
                background: 'none',
                borderRadius: '0',
                '&:hover': {
                    bgcolor: 'background.default',
                    borderRadius: '0',
                },
                '&.Mui-expanded': {
                    minHeight: '24px',
                    bgcolor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                    borderRadius: '0',
                    '.MuiAccordionSummary-expandIconWrapper': {
                        color: '#FFFFFF',
                    },
                },
            },
            '.MuiAccordionSummary-content': {
                alignItems: 'center',
                overflow: 'hidden',
                margin: theme.spacing(0),
                '&.Mui-expanded': {
                    margin: theme.spacing(0),
                },
                '.MuiTypography-root:first-of-type': {
                    paddingRight: theme.spacing(1),
                },
                '.MuiTypography-root:last-of-type': {
                    paddingLeft: theme.spacing(2),
                },
            },
        }) },
        React.createElement(Scrollbar, null, events.map((value, key) => (React.createElement(Accordion, { key: key, expanded: expanded === value.alarmid, onChange: handleChangeAccordion(value.alarmid, value.time) },
            React.createElement(AccordionSummary, { disableRipple: true, expandIcon: React.createElement(ExpandMore, null) },
                React.createElement(Typography, { component: 'span' }, moment(value.time).format('DD.MM')),
                React.createElement(Typography, { component: 'span' }, moment(value.time).format('HH:mm:ss')),
                React.createElement(Typography, { component: 'span' },
                    "\u0421\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435 ",
                    value.type,
                    " - ",
                    (videoAdapter === null || videoAdapter === void 0 ? void 0 : videoAdapter.getEventLabel(value.type)) || value.type)),
            React.createElement(AccordionDetails, null,
                React.createElement(Paper, { variant: 'outlined' },
                    React.createElement(Stack, { className: 'MuiPaper-row' },
                        React.createElement(Typography, { variant: 'body1' }, "\u041C\u0435\u0441\u0442\u043E\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435"),
                        React.createElement(Typography, { variant: 'body1' },
                            value.gpslat,
                            ", ",
                            value.gpslng)),
                    React.createElement(Stack, { className: 'MuiPaper-row' },
                        React.createElement(Typography, { variant: 'body1' }, "\u0421\u043A\u043E\u0440\u043E\u0441\u0442\u044C"),
                        React.createElement(Typography, { variant: 'body1' },
                            value.speed,
                            " ",
                            config.conditions.speed.unit)),
                    React.createElement(Stack, { className: 'MuiPaper-row' },
                        React.createElement(Typography, { variant: 'body1' }, "\u0412\u044B\u0441\u043E\u0442\u0430"),
                        React.createElement(Typography, { variant: 'body1' },
                            value.altitude,
                            " ",
                            config.conditions.height.unit)),
                    React.createElement(Stack, { className: 'MuiPaper-row' },
                        React.createElement(Typography, { variant: 'body1' }, "\u041D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435"),
                        React.createElement(Typography, { variant: 'body1' },
                            value.direction,
                            " ",
                            config.conditions.course.unit))))))))));
};
export default MapTransportBroadcastEventList;
